function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { logger as N } from "../../shared-lib/index.js";
export function values(t) {
  var e = [];
  var r;

  for (var n in t) {
    r = n, Object.prototype.hasOwnProperty.call(t, r) && void 0 !== t[r] && e.push(t[r]);
  }

  return e;
}
export function validateValueIsFromEnum(t, e, r, n) {
  var o = values(t);
  return -1 !== o.indexOf(e) || (N.error("".concat(r, " Valid values from ").concat(n, " are \"").concat(o.join('"/"'), "\".")), !1);
}
export function isArray(t) {
  return Array.isArray ? Array.isArray(t) : "[object Array]" === Object.prototype.toString.call(t);
}
export function isDate(t) {
  return "[object Date]" === Object.prototype.toString.call(t);
}
export function isObject(t) {
  return "[object Object]" === Object.prototype.toString.call(t);
}
export function intersection(t) {
  for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    e[_key - 1] = arguments[_key];
  }

  null == t && (t = []);
  var r = [],
      n = arguments.length;

  for (var _e = 0, o = t.length; _e < o; _e++) {
    var _o = t[_e];
    if (-1 !== r.indexOf(_o)) continue;
    var c = 1;

    for (c = 1; c < n && -1 !== arguments[c].indexOf(_o); c++) {
      ;
    }

    c === n && r.push(_o);
  }

  return r;
}
export function keys(t) {
  var e = [];

  for (var r in t) {
    Object.prototype.hasOwnProperty.call(t, r) && e.push(r);
  }

  return e;
}
export function isEqual(t, e) {
  if (t === e) return 0 !== t || 1 / t == 1 / e;
  if (null == t || null == e) return t === e;
  var r = t.toString();
  if (r !== e.toString()) return !1;

  switch (r) {
    case "[object RegExp]":
    case "[object String]":
      return "" + t == "" + e;

    case "[object Number]":
      return +t != +t ? +e != +e : 0 == +t ? 1 / +t == 1 / e : +t == +e;

    case "[object Date]":
    case "[object Boolean]":
      return +t == +e;
  }

  var n = "[object Array]" === r;

  if (!n) {
    if ("object" != _typeof(t) || "object" != _typeof(e)) return !1;
    var _r = t.constructor,
        _n = e.constructor;
    if (_r !== _n && !("function" == typeof _r && _r instanceof _r && "function" == typeof _n && _n instanceof _n) && "constructor" in t && "constructor" in e) return !1;
  }

  var o = [],
      c = [];
  var i = o.length;

  for (; i--;) {
    if (o[i] === t) return c[i] === e;
  }

  if (o.push(t), c.push(e), n) {
    if (i = t.length, i !== e.length) return !1;

    for (; i--;) {
      if (!isEqual(t[i], e[i])) return !1;
    }
  } else {
    var _r2 = keys(t);

    var _n2;

    if (i = _r2.length, keys(e).length !== i) return !1;

    for (; i--;) {
      if (_n2 = _r2[i], !Object.prototype.hasOwnProperty.call(e, _n2) || !isEqual(t[_n2], e[_n2])) return !1;
    }
  }

  return o.pop(), c.pop(), !0;
}